import { useApprovalsFilters } from '../../../components/Stats/useApprovals';
import { Alert } from '@mui/material';
import { DataGridProps } from '@mui/x-data-grid';
import { ReactNode, useState } from 'react';
import BaseDialog from '@components/shared/Dialog/BaseDialog';
import { columns, ColumnsOptions } from './Campaigns/columns';
import { Campaign, CampaignsResponseSchema } from '@features/campaigns';
import { DataGrid } from '@mui/x-data-grid';

export const PAGE_SIZES = [10, 25, 50] as const;

type ReportApprovalsProps = {
  campaign: Campaign;
};

type CampaignApprovalsProps = {
  campaignsHook: {
    data?: CampaignsResponseSchema;
    isFetching: boolean;
    error?: unknown;
  };
  renderReportApprovals: (props: ReportApprovalsProps) => ReactNode;
  updateCampaign: ColumnsOptions['updateCampaign'];
};

export const CampaignApprovals = (props: CampaignApprovalsProps) => {
  const { data, isFetching, error } = props.campaignsHook;
  const campaigns = data?.campaigns;
  const total = data?.total;
  const {
    loadNextPage,
    loadPreviousPage,
    currentPage,
    pageSize,
    changePageSize,
  } = useApprovalsFilters();
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [activeCampaign, setActiveCampaign] = useState<Campaign | undefined>(
    undefined
  );

  if (error) return <Alert severity="error">Unable to load campaigns</Alert>;

  const dataGridPage = currentPage - 1;

  const onPaginationModelChange: DataGridProps['onPaginationModelChange'] =
    paginationModel => {
      if (paginationModel.pageSize !== pageSize) {
        changePageSize(paginationModel.pageSize);
        return;
      }

      if (paginationModel.page > dataGridPage) {
        loadNextPage();
      } else if (paginationModel.page < dataGridPage) {
        loadPreviousPage();
      }
    };

  return (
    <>
      <DataGrid
        columns={columns({
          updateCampaign: props.updateCampaign,
          onClickManageCampaign: campaign => {
            setActiveCampaign(campaign);
            setReportsDialogOpen(true);
          },
        })}
        rows={campaigns ?? []}
        pageSizeOptions={PAGE_SIZES}
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: PAGE_SIZES[0],
              page: dataGridPage,
            },
          },
        }}
        paginationModel={{
          pageSize: pageSize ?? PAGE_SIZES[0],
          page: dataGridPage,
        }}
        onPaginationModelChange={onPaginationModelChange}
        rowCount={total ?? 0}
        paginationMode="server"
        loading={isFetching}
        disableRowSelectionOnClick
        sx={{
          padding: '1rem',
          height: 'auto',
        }}
      />
      <BaseDialog
        title="Report Approvals"
        open={reportsDialogOpen}
        onClose={() => setReportsDialogOpen(false)}
        maxWidth="xl"
      >
        {activeCampaign ? (
          <props.renderReportApprovals campaign={activeCampaign} />
        ) : null}
      </BaseDialog>
    </>
  );
};
